<template>
    <Paper class="paper">
        <h2 class="headline  py-3 px-4 m-0">
            {{ $t('spotlight.workAuthorization.addWorkAuthorization') }}
        </h2>
        <Divider />
        <div class="content px-4 py-4">
            <div v-if="euButtonVisible" class="mb-3">
                <div class="d-flex flex-row-reverse mb-3">
                    <BaseButton variant="secondary" @click="onAddEu">
                        {{
                            $t(
                                'spotlight.workAuthorization.dialog.addEuWorkAuthorization'
                            )
                        }}
                    </BaseButton>
                </div>
                <Divider />
            </div>
            <h6 class="subtitle bold">
                {{ $t('spotlight.workAuthorization.dialog.selectCountry') }}
            </h6>

            <div class="d-flex flex-row-reverse mt-3">
                <BaseButton
                    class="ml-2"
                    variant="secondary"
                    :disabled="country === undefined"
                    @click="onAdd"
                >
                    {{ $t('general.add') }}
                </BaseButton>
                <BaseSearchable
                    v-model="country"
                    autocomplete="country-name"
                    :data="countries"
                />
            </div>

            <div class="d-flex flex-row-reverse mt-3">
                <Divider />
                <BaseButton
                    class="mr-3"
                    variant="text-secondary"
                    @click="onClose"
                    >{{ $t('general.close') }}
                </BaseButton>
            </div>
        </div>
    </Paper>
</template>

<script>
import allCountries from 'highered-utils/data/countries.json';
export default {
    name: 'WorkAuthorizationDialog',
    props: {
        existing: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        country: undefined,
        euButtonEnabled: false,
    }),
    computed: {
        countries() {
            if (this.existingCountryCodes !== undefined) {
                return allCountries.filter(
                    c => this.existingCountryCodes.includes(c.value) === false
                );
            } else {
                return allCountries;
            }
        },
        existingCountryCodes() {
            return this.existing.filter(v => v.type === 0).map(v => v.code);
        },
        euButtonVisible() {
            return (
                this.existing.find(v => v.code === 'EU' && v.type === 1) ===
                undefined
            );
        },
    },
    methods: {
        onClose() {
            this.clear();
            this.$emit('close');
            this.$interfaces.dialogModal.getState().resolver.res();
        },
        clear() {
            this.country = undefined;
        },
        onAdd() {
            if (!this.isValidInput()) {
                return;
            }

            const data = {
                type: 0,
                code: this.country.value,
                implicit: false,
            };

            this.$emit('onAdd', data);
            this.onClose();
        },
        onAddEu() {
            const data = {
                type: 1,
                code: 'EU',
                implicit: false,
            };
            this.$emit('onAdd', data);
            this.onClose();
        },
        isValidInput() {
            return this.country !== undefined;
        },
    },
    mounted() {},
    watch: {},
};
</script>

<style scoped>
.paper {
    width: 96%;
    max-width: 600px;
}

@media only screen and (max-width: 600px) {
    .paper {
        width: 100%;
        padding-bottom: 100px;
        border-radius: 0 !important;
    }
}
</style>
